export default __webpack_public_path__ + "static/media/snapchat-light.ae4d0dbb.svg";